export default __webpack_public_path__ + "static/media/icon_holiday_cal.de59c71f.svg";